export const ar = {
  nav: {
    home: "الرئيسية",
    services: "الخدمات",
    products: "المنتجات",
    packages: "الباقات",
    offers: "العروض والخصومات",
    myGarage: "المرآب",
    wishlist: "المفضلة",
    about: "من نحن",
    contact: "اتصل بنا",
    news: "الأخبار",
    login: "تسجيل الدخول",
    accountMenu: "قائمة الحساب",
    myProfile: "ملفي الشخصي",
    myAccount: "حسابي",
    logout: "تسجيل الخروج",
    search: "بحث...",
    loyaltyPoints: "نقاط الولاء",
    pts: "نقاط",
    menu: "القائمة",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    switchToEnglish: "التبديل إلى الإنجليزية",
    switchToArabic: "التبديل إلى العربية",
    chooseCity: "اختر المدينة",
    cityList: "المدن",
    loadingCities: "جاري تحميل المدن…",
    citiesError: "تعذر تحميل المدن. حاول لاحقاً.",
    noCities: "لا توجد مدن.",
    loadMoreCities: "تحميل المزيد",
    searchCities: "ابحث عن مدينة…",
    mega: {
      services: {
        allTitle: "جميع خدمات السيارات",
        allDesc:
          "استكشف تغيير الزيت والفرامل والتكييف والإطارات وغيرها عبر شبكة ورشنا الاحترافية.",
        periodicTitle: "الصيانة الدورية",
        periodicDesc:
          "فحوصات مجدولة وفلات وزيوت لحماية المحرك والضمان سنة تلو الأخرى.",
        workshopTitle: "ابحث عن ورشة",
        workshopDesc:
          "حدد أقرب مركز بترومين مع الساعات والاتجاهات وبيانات التواصل في مكان واحد.",
        garageTitle: "مرآبي",
        garageDesc:
          "احفظ المركبات واعرض السجل وابقَ على التذكيرات مرتبطة بحسابك لدى بترومين.",
      },
      products: {
        careTitle: "منتجات العناية",
        careDesc:
          "تلميع وتنظيف وحماية للحفاظ على الطلاء والزجاج والمقصورة بين الزيارات.",
      },
      packages: {
        allTitle: "جميع الباقات",
        allDesc:
          "قارن خطط الخدمة المجمّعة حسب المسافة ونوع المركبة لاختيار مسار الصيانة المناسب.",
        comboTitle: "عروض ومجموعات",
        comboDesc:
          "باقات موسمية تجمع الخدمات والمنتجات مع توفير إضافي للأعضاء والزوار الجدد.",
      },
      offers: {
        currentTitle: "العروض الحالية",
        currentDesc:
          "اطلع على الخصومات الفعّالة على الورش والتجزئة ومكافآت الولاء المحدّثة باستمرار.",
      },
      about: {
        expressTitle: "خدمة سريعة",
        expressDesc: "بترومين إكسبرس.",
        careTitle: "إصلاح ميكانيكي",
        careDesc: "بترومين أوتو كير",
        evServicesTitle: "خدمات السيارات الكهربائية",
        evServicesDesc:
          "التنقل الكهربائي وإصلاح الجهد العالي والتشخيص وشبكة الشحن وحلول الأساطيل عبر شبكة بترومين.",
        bodyPaintTitle: "الهيكل والطلاء",
        bodyPaintDesc: "بترومين للهيكل والطلاء",
        commercialTitle: "إصلاح المركبات التجارية",
        commercialDesc: "بترومين لعناية المركبات التجارية",
        evChargingTitle: "محطات شحن السيارات الكهربائية",
        evChargingDesc:
          "توسيع شبكة الشواحن والوصول إلى الشحن في مواقع بترومين المختارة، لتمكين عملاء المركبات الكهربائية من الشحن بسهولة.",
        luxuryRepairTitle: "إصلاح السيارات الفاخرة",
        luxuryRepairDesc: "بترومين أوتو كير بريميوم",
        globalTitle: "من نحن",
        globalDesc:
          "من جذور سعودية إلى توسع إقليمي، كيف نقدم جودة متسقة في مئات المواقع.",
        autoPartsTitle: "توزيع قطع الغيار",
        autoPartsDesc: "ناشونال أوتو بارتس",
        oilStopTitle: "خدمة زيت الامتياز",
        oilStopDesc: "ناشونال أويل ستوب",
        tristarTitle: "خدمات إصلاح ثقيلة",
        tristarDesc: "بترومين تريستار",
      },
      contact: {
        reachTitle: "قنوات التواصل",
        reachDesc:
          "اتصل بالخط الساخر أو راسل الدعم أو راجع أوقات العمل للفوترة والحجز والمساعدة.",
        locationsTitle: "خريطة الورش",
        locationsDesc:
          "ابحث عن الأحياء والمدن للعثور على فنيين معتمدين وقطع أصلية قريبة منك.",
      },
    },
  },
  location: {
    riyadh: "الرياض",
  },
  homeHero: {
    headlineBold: "خدمات متميزة",
    headlineRegular: " لـ ",
    headlineSemi: "سيارتك",
    brakeServices: "خدمات الفرامل",
    brakeServicesAlt: "مجموعة قرص الفرامل",
    airFilterAlt: "فلتر الهواء",
    engineOilAlt: "زيت المحرك",
    showAllServices: "عرض جميع الخدمات ←",
    tabServices: "الخدمات",
    tabProducts: "المنتجات",
    tabPackages: "الباقات",
    searchPlaceholder: "ابحث عن الخدمات",
    searchPlaceholderServices: "ابحث عن خدمة أو قطع غيار",
    searchPlaceholderProducts: "ابحث في المنتجات…",
    searchPlaceholderPackages: "ابحث في الباقات…",
    searchButton: "بحث",
    searchSuggestionsLoading: "جارٍ تحميل الاقتراحات…",
    searchNoResults: "لا توجد نتائج. اضغط بحث لعرض كل النتائج.",
    searchSeeAllPrefix: "عرض كل النتائج لـ",
    dealTitle: "عرض اليوم",
    dealDesc:
      "استبدال زيت بترومين مجاناً عند شراء صيانة دورية لمدة 3 سنوات أو أكثر",
    availNow: "احصل عليه الآن",
    carouselAria: "خدمات مميزة",
    carouselBrake: "خدمة الفرامل",
    carouselBattery: "خدمة البطاريات",
    carouselEngine: "خدمة المحرك",
    carouselAC: "خدمة التكييف",
    viewServicesForCategory: "عرض الخدمات لـ",
  },
  search: {
    showingResultsFor: "عرض النتائج لـ",
    clear: "مسح",
    noMatches: "لا توجد نتائج مطابقة لبحثك.",
  },
  hero: {
    slide1Title: "عناية عالمية بسيارتك، قريبة منك.",
    slide1Sub: "ورشة خدمة عالية التقنية مع فنيين معتمدين.",
    slide2Title: "خدمة متميزة لسيارتك المتميزة.",
    slide2Sub: "مرافق حديثة وقطع غيار أصلية.",
    slide3Title: "رعاية موثوقة، في كل ميل.",
    slide3Sub: "من الصيانة الدورية إلى الإصلاحات المعقدة.",
    bookService: "ابحث عن الورشة",
    browseBy: "تصفح حسب الفئة",
    selectType: "الخدمات أو المنتجات أو الباقات",
    services: "الخدمات",
    products: "المنتجات",
    packages: "الباقات",
    viewServices: "عرض الخدمات",
    viewProducts: "عرض المنتجات",
    viewPackages: "عرض الباقات",
    selectCategory: "اختر فئة الخدمة",
    selectProductCategory: "اختر فئة المنتج",
    selectPackageCategory: "اختر فئة الباقة",
    selectTypeFirst: "اختر النوع أولاً",
    exploreNow: "استكشف الآن",
    includingVAT: "(يشمل الضريبة)"
  },
  howItWorks: {
    badge: "عملية بسيطة",
    title: "كيف تعمل بترومين",
    subtitle: "ثلاث خطوات سهلة لعناية عالمية بسيارتك. احجز أونلاين، زر مركزنا، وانطلق بثقة.",
    step1Title: "اختر خدمتك",
    step1Desc: "تصفح الخدمات أو الباقات أو المنتجات. اختر ما تحتاجه سيارتك وأضفه للسلة في ثوانٍ.",
    step2Title: "ابحث وزر",
    step2Desc: "تصفّح الخدمات المتاحة، اختر أقرب مركز لك، وجيب سيارتك في الوقت اللي يناسبك.",
    step3Title: "انطلق سعيداً",
    step3Desc: "سنخبرك عندما تكون جاهزة. استلم سيارتك وانطلق بثقة.",
    getStarted: "ابدأ الآن",
    findCenter: "ابحث عن أقرب مركز",
  },
  services: {
    title: "جميع خدمات السيارات في السعودية",
    subtitle: "اكتشف خدمات إصلاح وصيانة السيارات الخبيرة في المملكة مع بترومين. من تغيير الزيت والعناية بالإطارات إلى الفرامل والتعليق والإصلاحات الكهربائية — اعثر على أقرب ورشة بترومين واحجز خدمتك أونلاين بسهولة.",
    allServices: "جميع الخدمات",
    periodic: "الخدمات الدورية",
    acRepair: "إصلاح المكيف",
    batteries: "البطاريات",
    tyres: "الإطارات",
    detailing: "التلميع",
    customRepairs: "إصلاحات مخصصة",
    sortBy: "ترتيب حسب:",
    mostPopular: "الأكثر شعبية",
    priceLow: "السعر: من الأقل للأعلى",
    priceHigh: "السعر: من الأعلى للأقل",
    highestRated: "الأعلى تقييماً",
    whatsIncluded: "ما المدرج",
    whenNeeded: "متى تحتاجها",
    bookService: "ابحث عن الورشة",
    quickAdd: "إضافة سريعة",
    freeCancellation: "إلغاء مجاني حتى 24 ساعة قبل الموعد",
    trustBadgesAria: "ضمانات جودة الخدمة",
    trustCertifiedLine1: "فنيون",
    trustCertifiedLine2: "معتمدون",
    trustGenuineLine1: "قطع",
    trustGenuineLine2: "أصلية",
    relatedServices: "خدمات ذات صلة",
    serviceNotFound: "الخدمة غير موجودة",
    serviceNotFoundDesc: "الخدمة التي تبحث عنها غير موجودة أو تم إزالتها.",
    backToServices: "العودة للخدمات",
    warranty: "الضمان",
    serviceInterval: "فترة الصيانة",
    browseByCategory: "تصفح حسب التصنيف",
    categorySheetTitle: "اختر التصنيف",
    categoriesAriaLabel: "تصفية الخدمات حسب التصنيف",
    mobileOpenCategories: "فتح خيارات التصنيف",
    mobileOpenFilters: "فتح التصفية والترتيب",
    loadError: "تعذر تحميل الخدمات. يرجى تحديث الصفحة.",
    detailWhatsIncludedTitle: "ما المُدرَج في هذه الخدمة",
    detailServiceBenefitsTitle: "مزايا الخدمة",
    desktopFilters: "عوامل التصفية",
    filterCategory: "التصنيف",
    filterSort: "الترتيب",
    filterPrice: "السعر",
    enterPriceRange: "أدخل نطاق السعر",
    minPrice: "الحد الأدنى",
    maxPrice: "الحد الأعلى",
    applyPriceFilter: "تطبيق",
    clearFilters: "مسح الكل",
    clearPrice: "مسح",
    chooseSort: "ترتيب العرض",
    clearSort: "مسح",
    expandSection: "توسيع",
    collapseSection: "طي",
    loadingMoreServices: "جاري تحميل المزيد…",
    allServicesShown: "تم عرض جميع الخدمات.",
  },
  products: {
    title: "منتجات السيارات",
    subtitle: "تسوق قطع غيار أصلية وزيت وفلاتر ومنتجات العناية بالسيارة. منتجات عالية الجودة لسيارتك، متوفرة للاستلام أو التوصيل.",
    allProducts: "جميع المنتجات",
    oilsFluids: "الزيوت والسوائل",
    filters: "الفلاتر",
    brakeParts: "قطع الفرامل",
    electrical: "الكهرباء",
    carCare: "العناية بالسيارة",
    accessories: "الإكسسوارات",
    newest: "الأحدث",
    inStock: "متوفر",
    sale: "تخفيض",
    addToCart: "أضف للسلة",
    buyNow: "اشتري الآن",
    deliveryNote: "توصيل مجاني للطلبات فوق 50 {{CURRENCY}}. استلام متاح من جميع المراكز.",
    relatedProducts: "منتجات ذات صلة",
    productNotFound: "المنتج غير موجود",
    productNotFoundDesc: "المنتج الذي تبحث عنه غير موجود أو تم إزالته.",
    backToProducts: "العودة للمنتجات",
    loadError: "تعذر تحميل المنتجات. يرجى تحديث الصفحة.",
    empty: "لا توجد منتجات متاحة حالياً.",
    loadingMoreProducts: "جاري تحميل المزيد…",
    allProductsShown: "تم عرض جميع المنتجات.",
    detailLoadError: "تعذر تحميل هذا المنتج. حاول مرة أخرى أو ارجع إلى القائمة.",
    aboutProduct: "عن المنتج",
    includedServices: "الخدمات المشمولة",
    includedServiceFallback: "خدمة مشمولة",
    keyBenefits: "أهم المزايا",
    youSave: "وفّر",
    galleryPrev: "الصورة السابقة",
    galleryNext: "الصورة التالية",
    browseByCategory: "تصفح حسب التصنيف",
    categorySheetTitle: "اختر التصنيف",
    categoriesAriaLabel: "تصفية المنتجات حسب التصنيف",
  },
  packages: {
    title: "باقات الخدمات",
    subtitle: "وفر أكثر مع باقات الخدمات المجمعة. كل باقة تجمع عدة خدمات بسعر مخفض للعناية الشاملة بسيارتك.",
    allPackages: "جميع الباقات",
    maintenance: "الصيانة",
    acClimate: "المكيف والمناخ",
    safety: "السلامة",
    tyres: "الإطارات",
    detailing: "التلميع",
    seasonal: "موسمية",
    electrical: "الكهرباء",
    bestSavings: "أفضل توفير",
    browseByCategory: "تصفح حسب التصنيف",
    categorySheetTitle: "اختر التصنيف",
    categoriesAriaLabel: "تصفية الباقات حسب التصنيف",
    saveBadge: "وفر {{percent}}٪",
    servicesIncluded: "الخدمات المدرجة",
    bookPackage: "ابحث عن الورشة",
    relatedPackages: "باقات ذات صلة",
    packageNotFound: "الباقة غير موجودة",
    packageNotFoundDesc: "الباقة التي تبحث عنها غير موجودة أو تم إزالتها.",
    backToPackages: "العودة للباقات",
    loadError: "تعذّر تحميل الباقات. يرجى تحديث الصفحة.",
    empty: "لا توجد باقات تطابق عوامل التصفية.",
    loadingMorePackages: "جاري تحميل المزيد…",
    allPackagesShown: "تم عرض جميع الباقات.",
  },
  offers: {
    title: "العروض والخصومات",
    subtitle: "وفر أكثر على العناية بسيارتك مع عروضنا الحصرية. عروض موسمية، خصومات للعملاء الجدد، ومكافآت الولاء للخدمات والمنتجات والباقات.",
    allOffers: "جميع العروض",
    availabilityAll: "الكل",
    availabilityLabel: "الحالة:",
    filterAvailable: "متاحة",
    filterExpired: "منتهية",
    mobileOpenSort: "فتح خيارات الترتيب",
    mobileOpenFilter: "فتح تصفية الحالة",
    sortSheetTitle: "ترتيب حسب",
    filterSheetTitle: "الحالة",
    seasonal: "موسمية",
    newCustomer: "عميل جديد",
    electrical: "كهرباء",
    loyalty: "الولاء",
    expiringSoon: "تنتهي قريباً",
    highestDiscount: "أعلى خصم",
    lowestDiscount: "أقل خصم",
    validUntil: "صالح حتى",
    termsConditions: "الشروط والأحكام",
    usePromoCode: "استخدم رمز الخصم عند الدفع",
    yourOfferCode: "رمز عرضك",
    claimOffer: "احصل على هذا العرض",
    moreOffers: "المزيد من العروض",
    offerNotFound: "العرض غير موجود",
    offerNotFoundDesc: "العرض الذي تبحث عنه غير موجود أو انتهت صلاحيته.",
    backToOffers: "العودة للعروض",
    loadError: "تعذر تحميل العروض. يرجى تحديث الصفحة.",
    empty: "لا توجد عروض متاحة حالياً.",
    specialOffer: "عرض خاص",
    couponAvailable: "قسيمة متاحة",
    viewOffer: "عرض العرض",
    browseByCategory: "تصفح حسب التصنيف",
    categorySheetTitle: "اختر التصنيف",
    categoriesAriaLabel: "تصفية العروض حسب التصنيف",
    ticketScanHint: "امسح هذا الرمز عند الدفع أو أظهر هذه الشاشة للموظف.",
    ticketPriceDetails: "",
    ticketKickerDefault: "عرض حصري",
    ticketFooter1: "اعرض هذا العرض في مواقع بترومين المشاركة.",
    ticketFooter2: "يخضع للتوفر وكامل شروط هذا العرض.",
    ticketFooter3: "يجوز لبترومين تعديل أو سحب هذا العرض دون إشعار مسبق.",
    ticketFooter4: "شكراً لاختيارك بترومين.",
    ticketDescriptionHeading: "عن هذا العرض",
    ticketLoading: "جاري تحميل العرض…",
    ticketLoadFailed: "تعذر تحميل هذا العرض. حاول لاحقاً.",
    ticketExpiresIn: "ينتهي العرض خلال {{days}} يوماً",
    offerGoesLiveIn: "يبدأ العرض خلال",
    offerEndsIn: "ينتهي العرض خلال",
    countdownDays: "أيام",
    countdownHours: "ساعات",
    countdownMins: "دقائق",
    countdownSecs: "ثوانٍ",
    countdownAria:
      "يتبقى على انتهاء هذا العرض {{days}} يوماً و{{hours}} ساعة و{{mins}} دقيقة و{{secs}} ثانية",
    ticketBenefitsHeading: "المزايا",
    viewCoupon: "عرض القسيمة",
    viewCouponCode: "عرض رمز القسيمة",
    couponRevealCongratulations: "تهانينا!",
    couponRevealCopyHint: "انسخ الرمز عند الدفع",
    couponRevealRevealCta: "اكشف الرمز",
    couponRevealCopyButton: "انقر لنسخ الرمز",
    couponRevealCopied: "تم النسخ!",
    couponRevealContinue: "متابعة",
    couponRevealCloseAria: "إغلاق",
    trendingServices: "الخدمات المتداولة",
    footerTitle: "تملك سيارة؟",
    footerSubtitle:
      "حمّل تطبيق PETROMINit لتبقى على اطلاع باحتياجات سيارتك",
    footerChipMaintenance: "الصيانة",
    footerChipServices: "الخدمات",
    footerChipRewards: "المكافآت",
    footerChipMore: "+3",
    footerWorkshopsStat: "650+",
    footerWorkshopsLabel: "ورشة في أنحاء المملكة",
    footerDownloadsStat: "100K+",
    footerDownloadsLabel: "تحميل للتطبيق",
    footerPhonesAlt: "تطبيق PETROMINit على الهواتف المحمولة",
  },
  news: {
    title: "آخر الأخبار",
    subtitle: "ابق على اطلاع بأخبار بترومين، نصائح العناية بالسيارة، ومعلومات الصناعة.",
    allNews: "جميع الأخبار",
    companyNews: "أخبار الشركة",
    tipsGuides: "نصائح ومرشدات",
    partnerships: "الشراكات",
    newestFirst: "الأحدث أولاً",
    oldestFirst: "الأقدم أولاً",
    readMore: "اقرأ المزيد",
    relatedArticles: "مقالات ذات صلة",
    articleNotFound: "المقال غير موجود",
    articleNotFoundDesc: "المقال الذي تبحث عنه غير موجود أو تم إزالته.",
    backToNews: "العودة للأخبار",
    viewAllNews: "عرض جميع الأخبار",
    browseByTopic: "تصفح حسب الموضوع",
    categoriesAriaLabel: "تصفية الأخبار حسب التصنيف",
    categorySheetTitle: "اختر التصنيف",
    mobileOpenCategories: "فتح خيارات التصنيف",
  },
  notifications: {
    title: "الإشعارات",
    open: "فتح الإشعارات",
    close: "إغلاق",
    empty: "لا توجد إشعارات حتى الآن.",
    loadError: "تعذر تحميل الإشعارات. حاول مرة أخرى.",
    missingCustomerId:
      "لا يتضمن جلستك معرّف العميل بعد. عندما يعيد تسجيل الدخول إرجاع customer_id ستظهر الإشعارات هنا. للتجربة محلياً، عيّن NEXT_PUBLIC_PETROMIN_CUSTOMER_ID في البيئة.",
    fallbackTitle: "إشعار",
  },
  topServices: {
    title: "أفضل الخدمات والباقات",
    viewAll: "عرض جميع الخدمات",
    quickAdd: "إضافة سريعة",
    savePercent: "وفر",
    reviews: "تقييمات",
  },
  offersSection: {
    title: "العروض والخصومات",
    subtitle: "عروض حصرية لعناية السيارات",
    viewAll: "عرض جميع العروض",
    ramadanTitle: "عرض رمضان",
    ramadanSub: "حتى 30% خصم على خدمات مختارة",
    ramadanDesc: "عروض حصرية خلال الشهر الكريم. احجز الآن ووفر.",
    viewOffers: "عرض العروض",
    limitedTime: "وقت محدود",
    expiredBadge: "انتهى",
    referTitle: "ادعُ صديقاً",
    referSub: "احصل على 20 {{CURRENCY}} رصيد",
    referDesc: "شارك الحب. كلاكما يحصل على مكافآت عند الحجز.",
    referNow: "ادعُ الآن",
    earnRewards: "اكسب مكافآت",
    firstVisitTitle: "خصم الزيارة الأولى",
    firstVisitSub: "15% خصم على أول خدمة",
    firstVisitDesc: "جديد على بترومين؟ استمتع بخصم ترحيبي.",
    claimOffer: "احصل على العرض",
    newCustomers: "عملاء جدد",
  },
  latestNews: {
    title: "آخر الأخبار",
    subtitle: "ابق على اطلاع بأخبار بترومين ونصائح وصناعة السيارات",
    viewAll: "عرض جميع الأخبار",
  },
  findWorkshopPage: {
    breadcrumb: "ابحث عن ورشة",
    title: "اعثر على ورشة قريبة منك",
    intro:
      "اعرض أقرب محطات خدمة بترومين وساعات العمل والخريطة. استخدم تحديد الموقع لترتيب النتائج حسب المسافة.",
    moreCategories: "المزيد",
    moreCategoriesDialogTitle: "المزيد من الفئات",
    closeDialog: "إغلاق",
  },
  findWorkstationPage: {
    breadcrumb: "ابحث عن محطة عمل",
    title: "اعثر على محطة عمل قريبة منك",
    intro:
      "قائمة مباشرة من بترومين: أقرب المحطات وساعات العمل والتقييمات والاتجاهات. استخدم تحديد الموقع للبحث من موقعك.",
  },
  workstations: {
    openingHours: "ساعات العمل",
    resultsRange: "عرض {from}–{to} من {total}",
    loading: "جاري تحميل المحطات…",
    locating: "جاري تحديد الموقع…",
    loadFailed: "تعذر تحميل المحطات. حاول مرة أخرى.",
    noResults: "لا توجد محطات في هذه المنطقة.",
    previous: "السابق",
    next: "التالي",
    pageInfo: "صفحة {page} من {totalPages}",
    reviews: "تقييم",
    call: "اتصل",
    searchFromHere: "البحث من هذا الموقع",
    closeDetails: "إغلاق التفاصيل",
    mapDistance: "المسافة",
    openStatusOpen: "مفتوح",
    openStatusClosed: "مغلق",
    openStatusCloses: "يغلق {time}",
    openStatusOpens: "يفتح {time}",
  },
  serviceCenter: {
    allCategories: "كل الفئات",
    selectSubcategory: "الفئة الفرعية",
    chipCategory: "الفئة",
    chipSubcategory: "الفئة الفرعية",
    categoriesLoadFailed: "تعذّر تحميل الفئات.",
    searchPlaceholder: "ابحث عن موقع",
    share: "مشاركة",
    contact: "اتصل",
    noMatches: "لا توجد مراكز مطابقة لبحثك.",
    detectLocation: "تحديد موقعي",
    seeAllWorkstations: "عرض الكل",
    open: "مفتوح",
    closed: "مغلق",
    directions: "الاتجاهات",
    bookService: "ابحث عن الورشة",
    closesAt: "يغلق",
    opensAt: "يفتح",
    minDrive: "دقيقة بالسيارة",
    findWorkshopNearby: "ابحث عن ورشة بترومين قريبة منك",
  },
  categories: {
    browseBy: "تصفح حسب الفئة",
    sectionTitle: "خدمات السيارات",
    viewAll: "عرض جميع الخدمات",
    more: "المزيد",
    periodic: "الخدمات الدورية",
    acRepair: "إصلاح المكيف",
    batteries: "البطاريات",
    tyres: "الإطارات",
    detailing: "التلميع",
    customRepairs: "إصلاحات مخصصة",
  },
  pagination: {
    showing: "عرض",
    of: "من",
    previous: "السابق",
    next: "التالي",
    services: "خدمات",
    products: "منتجات",
    packages: "باقات",
    offers: "عروض",
    articles: "مقالات",
    reviews: "تقييمات",
    items: "عناصر",
  },
  ratings: {
    title: "التقييمات والمراجعات",
    reviews: "تقييمات",
    star: "نجمة",
    stars: "نجوم",
    verified: "موثق",
    noReviews: "لا توجد مراجعات بعد. كن أول من يشارك تجربته!",
    locations: "مواقع",
    writeReview: "اكتب مراجعة",
    yourRating: "تقييمك",
    reviewPlaceholder: "شارك تجربتك مع الآخرين…",
    submitReview: "إرسال المراجعة",
    thankYouReview: "شكرًا لملاحظاتك.",
    selectStars: "يرجى اختيار عدد النجوم.",
    reviewRequired: "يرجى كتابة مراجعتك.",
    loginToReview: "سجّل الدخول لإرسال مراجعة.",
    reviewNotConfigured:
      "لا يمكن إرسال المراجعات من هذه الصفحة (منتج أو مركز خدمة غير محدد).",
    reviewSubmitFailed: "تعذّر إرسال المراجعة. حاول مرة أخرى.",
    submittingReview: "جاري الإرسال…",
    v2ReviewsOn: "تقييمًا على",
    v2WriteReviewAndGet: "اكتب مراجعة واحصل على",
    v2Points: "نقطة",
    v2ReadAllReviews: "عرض جميع التقييمات",
    v2GoogleAlt: "جوجل",
    loadingReviews: "جاري تحميل المراجعات…",
    rateReviewTitle: "قيّم وأضف مراجعة",
    overallExperiencePrompt: "كيف كانت تجربتك بشكل عام؟",
    reviewDescriptionPlaceholder: "أخبرنا عن تجربتك",
    reviewTitlePlaceholder: "عنوان مراجعتك",
    addPhotosVideos: "إضافة صور وفيديوهات",
    submitReviewButton: "إرسال المراجعة",
    closeReviewDialog: "إغلاق",
    backCloseReview: "رجوع",
    mediaNotUploadedHint:
      "لا يتم رفع المرفقات بعد—سيتم إرسال نص المراجعة فقط.",
    reviewSubjectFallbackService: "هذه الخدمة",
    reviewSubjectFallbackProduct: "هذا المنتج",
    reviewSubjectFallbackPackage: "هذه الباقة",
  },
  footer: {
    tagline: "عناية عالمية بسيارتك قريبة منك. خدمات سيارات متميزة، قطع غيار أصلية، ورعاية خبيرة لسيارتك.",
    services: "الخدمات",
    products: "المنتجات",
    company: "الشركة",
    support: "الدعم",
    legal: "قانوني",
    periodicServices: "الخدمات الدورية",
    acRepair: "إصلاح المكيف",
    batteries: "البطاريات",
    tyres: "الإطارات",
    detailing: "التلميع",
    customRepairs: "إصلاحات مخصصة",
    oilsFluids: "الزيوت والسوائل",
    filters: "الفلاتر",
    brakeParts: "قطع الفرامل",
    carCare: "العناية بالسيارة",
    aboutUs: "من نحن",
    contactUs: "اتصل بنا",
    careers: "الوظائف",
    newsBlog: "الأخبار والمدونة",
    helpCenter: "مركز المساعدة",
    faqs: "الأسئلة الشائعة",
    trackOrder: "تتبع الطلب",
    nearestCenters: "أقرب المراكز",
    sitemap: "خريطة الموقع",
    privacyPolicy: "سياسة الخصوصية",
    termsOfService: "شروط الخدمة",
    cookiePolicy: "سياسة الكوكيز",
    contact: "الاتصال:",
    email: "البريد:",
    copyrightLine:
      "حقوق النشر {{year}} بترومين اكسبريس تعمل بواسطة شركة الوطنية لثقة السيارات (National Auto Trust Company)، جميع الحقوق محفوظة، السجل التجاري رقم: 4030494886، الرقم الضريبي: 311499129200003، عنوان المكتب: المحمدية، جدة، المملكة العربية السعودية 23618",
  },
  contact: {
    title: "اتصل بنا",
    subtitle: "لديك أسئلة أو تحتاج مساعدة؟ فريقنا هنا لمساعدتك في كل احتياجاتك للسيارات.",
    getInTouch: "تواصل معنا",
    address: "العنوان",
    complaints: "الشكاوى والاستفسارات",
    workingHours: "ساعات العمل",
    petrominExpress: "بترومين إكسبرس",
    petrominAutocare: "بترومين أوتو كير",
    petrominBodyPaint: "بترومين للهيكل والطلاء",
    petrominCommercialVehicles: "بترومين لعناية المركبات التجارية",
    hoursLabelMonThuSatSun: "الإثنين–الخميس، السبت–الأحد",
    hoursExpressWeekdays: "8:00 ص – 11:30 م",
    hoursExpressFriday: "4:00 م – 10:00 م",
    hoursAutocareWeekdays: "8:00 ص – 9:30 م",
    hoursBodyPaintWeekdays: "8:00 ص – 5:00 م",
    hoursCommercialWeekdays: "8:00 ص – 5:00 م",
    hoursClosed: "مغلق",
    friday: "الجمعة",
    sendMessage: "أرسل لنا رسالة",
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    verifyPhone: "تحقق",
    phoneVerified: "تم التحقق",
    verifyPhoneTitle: "تحقق من رقم جوالك",
    verifyPhoneOtpSubtext: "أرسلنا رمزاً من 4 أرقام إلى",
    verifyOtpSubmit: "تأكيد الرمز",
    closePhoneVerifyModal: "إغلاق التحقق",
    phoneVerifyRequired:
      "يُرجى التحقق من رقم جوالك بالرمز المرسل قبل إرسال الرسالة.",
    phoneVerifyHint:
      "اضغط «تحقق من الجوال» لاستلام الرمز عبر الرسائل. المستخدمون المسجلون يستخدمون الجوال المرتبط بحسابهم.",
    city: "المدينة",
    howFound: "كيف عرفت عنا؟",
    message: "الرسالة",
    namePlaceholder: "اسمك",
    emailPlaceholder: "بريدك@الإلكتروني.com",
    messagePlaceholder: "كيف يمكننا مساعدتك؟",
    selectCity: "اختر المدينة",
    selectOption: "اختر الخيار",
    sendBtn: "إرسال الرسالة",
    sending: "جاري الإرسال...",
    findCenter: "ابحث عن أقرب مركز",
    newsletter: "أرسل لي آخر الأخبار والعروض والترويجات",
    agree: "أوافق على الشروط والأحكام وسياسة الخصوصية",
    socialMedia: "وسائل التواصل (فيسبوك، إنستغرام، تويتر)",
    google: "جوجل / محرك البحث",
    sms: "رسالة نصية",
    friend: "صديق / زميل",
    others: "أخرى",
    introFull:
      "هل لديك أسئلة أو تحتاج إلى مساعدة؟ فريقنا هنا لمساعدتك في جميع احتياجاتك المتعلقة بالسيارات. تواصل معنا وسنرد عليك في أقرب وقت ممكن.",
    addressLine1: "المحمدية، جدة",
    addressLine2: "المملكة العربية السعودية 23618",
    emailContactLabel: "البريد الإلكتروني",
    nameRequired: "الاسم *",
    emailRequired: "البريد الإلكتروني *",
    messageRequired: "الرسالة *",
    aboutTopic: "ما موضوع تواصلك معنا؟",
    reasonGeneralInquiry: "استفسار عام",
    reasonTechnicalSupport: "الدعم الفني / مشكلة",
    reasonBilling: "الفواتير / المدفوعات",
    reasonAccountLogin: "الحساب / تسجيل الدخول",
    reasonSalesPricing: "المبيعات / التسعير",
    reasonFeedback: "الملاحظات / الاقتراحات",
    reasonComplaint: "شكوى",
    reasonPartnership: "شراكة / أعمال",
    reasonReportAbuse: "الإبلاغ عن مشكلة / إساءة",
    reasonOther: "أخرى",
    legalIntro:
      "بإرسال هذه الرسالة، تؤكد أنك قد قرأت ووافقت على ",
    legalTermsLink: "الشروط والأحكام",
    legalMid: " و",
    legalPrivacyLink: "سياسة الخصوصية",
    legalEnd: ".",
    phoneNationalPlaceholder: "5 1234 5678",
    whatsappAria: "تواصل معنا عبر واتساب",
    submitSuccess: "شكراً لك — تم إرسال رسالتك. سنعود إليك قريباً.",
    submitError: "تعذر إرسال رسالتك. يُرجى المحاولة مرة أخرى بعد قليل.",
    submitErrorNetwork: "حدث خطأ ما. تحقق من اتصالك ثم أعد المحاولة.",
    marketingCommunications: "التواصل التسويقي",
    byContinuingYouAgreeTo: "باستمرار، أنت توافق على ",
    comma: ",",
    and: " و ",
  },
  login: {
    signIn: "تسجيل الدخول",
    verifyTitle: "تحقق من رقمك",
    phoneSubtext: "أدخل رقم هاتفك لاستلام كلمة مرور لمرة واحدة",
    otpSubtext: "أرسلنا رمزاً من 4 أرقام إلى",
    phoneLabel: "رقم الهاتف",
    otpLabel: "أدخل رمز التحقق",
    phonePlaceholder: "5 1234 5678",
    sendOtp: "إرسال الرمز",
    sending: "جاري الإرسال...",
    verifySignIn: "تحقق وتسجيل الدخول",
    verifying: "جاري التحقق...",
    resendOtp: "إعادة إرسال الرمز",
    resendIn: "إعادة الإرسال خلال",
    changePhone: "تغيير رقم الهاتف",
    /** Login dialog / compact UI */
    changeNumber: "تغيير الرقم",
    closeDialogAria: "إغلاق نافذة تسجيل الدخول",
    /** Footer with inline links (login page) */
    termsIntro: "بتسجيل الدخول، أنت توافق على ",
    termsOfService: "شروط الخدمة",
    termsAnd: " و ",
    privacyPolicy: "سياسة الخصوصية",
    secondsAbbrev: " ث",
    errorPhone: "يرجى إدخال رقم هاتف صحيح",
    errorSendOtp: "فشل إرسال الرمز. يرجى المحاولة مرة أخرى.",
    errorOtp: "يرجى إدخال الرمز المكون من 4 أرقام كاملاً",
    errorInvalidOtp: "رمز غير صحيح. يرجى المحاولة مرة أخرى.",
    errorResend: "فشل إعادة إرسال الرمز.",
    offerLoginTitle: "تسجيل الدخول للاستفادة من العرض",
    offerLoginSubtitle: "تحقق للاستفادة من العرض",
  },
  profile: {
    title: "ملفي الشخصي",
    phoneLabel: "رقم الجوال",
    loading: "جارٍ التحميل…",
    backHome: "العودة للرئيسية",
  },
  myAccount: {
    title: "حسابي",
    heroSubtitle:
      "ملفك الشخصي في بترومين ومركباتك المحفوظة في مكان واحد.",
    backHome: "العودة للرئيسية",
    loading: "جاري التحميل…",
    signedInAs: "مسجّل الدخول كـ",
    retry: "إعادة المحاولة",
    addFirstVehicle: "أضف مركبة",
    viewDetails: "عرض",
    profileSection: "معلومات الملف الشخصي",
    vehiclesSection: "مرآبك",
    vehicleCountOne: "مركبة واحدة",
    vehicleCountMany: "{{count}} مركبات",
    vehicleCardFooterCta: "عرض التفاصيل",
    vehicleCardRegionFallback: "المملكة العربية السعودية",
    vehicleCardSpecPlaceholder: "—",
    vehicleDetailScreenTitle: "تفاصيل المركبة",
    vehicleDetailBackAria: "العودة إلى قائمة المركبات",
    vehicleDetailNotFound: "هذه المركبة غير موجودة في مرآبك أو الرابط غير صالح.",
    vehicleDetailBackToList: "العودة إلى المركبات",
    vehicleDetailCarValue: "قيمة المركبة",
    vehicleDetailCarValueUnavailable: "غير متاحة",
    vehicleDetailCarValueCta: "احصل على التقييم",
    vehicleDetailKeyInformationHeading: "المعلومات الأساسية",
    vehicleDetailRegSection: "بيانات التسجيل",
    vehicleDetailKeySection: "التفاصيل الأساسية",
    vehicleDetailEditSection: "تعديل",
    vehicleDetailFieldOwner: "المالك",
    vehicleDetailFieldUserId: "معرّف المستخدم",
    vehicleDetailFieldOwnerId: "معرّف المالك",
    vehicleDetailFieldVin: "رقم الهيكل",
    vehicleDetailFieldPlate: "لوحة المركبة",
    vehicleDetailFieldRegType: "نوع التسجيل",
    vehicleDetailFieldRegDate: "تاريخ التسجيل",
    vehicleDetailFieldExpiry: "تاريخ الانتهاء",
    vehicleDetailFieldSequence: "الرقم التسلسلي",
    vehicleDetailFieldNationalId: "الهوية الوطنية",
    vehicleDetailFieldMake: "الماركة",
    vehicleDetailFieldModel: "الموديل",
    vehicleDetailFieldVariant: "الفئة",
    vehicleDetailFieldYear: "السنة",
    vehicleDetailFieldColour: "اللون",
    vehicleDetailFieldBodyType: "نوع الهيكل",
    vehicleDetailVinBannerTitle: "أكمل ملفك",
    vehicleDetailVinBannerGainLine: "أضف رقم الهيكل واكسب",
    vehicleDetailVinBannerPointsBadge: "100",
    vehicleDetailVinBannerBody:
      "أضف رقم الهيكل للاستفادة من نقاط الولاء وتجربة خدمة أوضح.",
    vehicleDetailVinBannerCta: "إضافة",
    manageGarage: "فتح مرآبي",
    loadingProfile: "جاري تحميل الملف…",
    loadingVehicles: "جاري تحميل المركبات…",
    profileError:
      "تعذر تحميل ملفك من بترومين. حاول مرة أخرى لاحقاً.",
    profileEmpty: "لم تُرجع الخدمة تفاصيل للملف.",
    noVehicles:
      "لا توجد مركبات مرتبطة بحسابك بعد. أضف مركبة من مرآبي.",
    missingCustomerId:
      "جلستك لا تتضمن معرّف العميل. سجّل الخروج ثم الدخول مجدداً أو تواصل مع الدعم.",
    fields: {
      firstName: "الاسم الأول",
      lastName: "اسم العائلة",
      fullName: "الاسم الكامل",
      name: "الاسم",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      mobile: "الجوال",
      gender: "الجنس",
      dateOfBirth: "تاريخ الميلاد",
      address: "العنوان",
      nationality: "الجنسية",
      city: "المدينة",
      country: "الدولة",
      language: "اللغة",
    },
    navVehicles: "المركبات",
    navLoyaltyNav: "الولاء",
    navNotifications: "الإشعارات",
    notificationsListSubtitle: "جميع إشعارات حسابك.",
    loadMoreNotifications: "تحميل المزيد",
    navHelp: "المساعدة",
    userProfileLabel: "الملف الشخصي",
    loyaltyProgramLabel: "برنامج الولاء",
    loyaltySubtitle: "برنامج المكافآت",
    availablePoints: "النقاط المتاحة",
    memberTier: "عضو",
    bronzeTier: "برونز",
    loyaltyMilestonesTitle: "مراحل المستوى",
    silverTier: "فضي",
    goldTier: "ذهبي",
    platinumTier: "بلاتيني",
    recentActivity: "النشاط الأخير",
    loyaltyRecentActivitySubtitle: "سجل الاكتساب والاستهلاك",
    tierBenefitsTitle: "مزايا مستواك",
    tierBenefitsIncludesLocked:
      "كل المزايا معروضة أدناه. اضغط مستوى للمعاينة: القفل يبقى حتى يصل مستواك الفعلي؛ البطاقة تصبح أوضح عندما يصل المستوى المختار لتلك الميزة.",
    tierBenefitsEmpty:
      "لا توجد مزايا مدرجة لحسابك حالياً. تحقق لاحقاً.",
    tierBenefitsLoadError: "تعذر تحميل مزايا المستوى. حاول مرة أخرى.",
    moreWaysToEarnTitle: "المزيد من طرق الكسب",
    waysToEarnLoadError: "تعذر تحميل فرص الكسب. حاول مرة أخرى.",
    waysToEarnCloseAria: "إغلاق",
    waysToEarnReferenceHeadlineFallback:
      "ادعُ واحصل على {{points}} نقطة",
    waysToEarnReferenceSubFallback:
      "اكسب نقاطاً عن كل صديق يسجّل باستخدام رمزك.",
    waysToEarnYourCodeLabel: "رمز الإحالة الخاص بك",
    waysToEarnNoCodeHint:
      "سيظهر الرمز هنا عند توفره في ملفك الشخصي.",
    waysToEarnSendInvite: "دعوة الأصدقاء",
    waysToEarnShareCodeLabel: "رمزي",
    waysToEarnReferralTitle: "لديك رمز إحالة؟",
    waysToEarnReferralPlaceholder: "أدخل الرمز",
    waysToEarnReferralSubmit: "إرسال",
    waysToEarnReferralSkip: "تخطّي",
    waysToEarnReferralCodeRequired: "يرجى إدخال رمز الإحالة.",
    waysToEarnReferralSubmitError:
      "تعذر تطبيق الرمز. حاول مرة أخرى.",
    waysToEarnEmailHeadlineFallback: "أضف بريدك الإلكتروني",
    waysToEarnEmailSubFallback:
      "أكمل بريدك الإلكتروني لتصلك التحديثات والمزايا المستحقة.",
    waysToEarnGenderHeadlineFallback: "أضف الجنس",
    waysToEarnGenderSubFallback:
      "حدّد جنسك لنساعد في تخصيص تجربتك.",
    waysToEarnGenderRequired: "يرجى اختيار خيار.",
    waysToEarnProfileUpdateError:
      "تعذر الحفظ. حاول مرة أخرى.",
    loyaltyPointsWord: "نقاط",
    loyaltyConvertedApprox: "≈ {{amount}}",
    loyaltyPointsForNextTier: "+{{points}} نقطة للوصول إلى {{tier}}",
    tierBenefitsUnlockHeading: "افتح المزايا المجانية لـ {{tier}}",
    tierBenefitsValidTill: "صالح حتى {{date}}",
    loyaltyNoteTitle: "ملاحظة:",
    loyaltyNote48h: "قد تستغرق نقاط المشتريات حتى 48 ساعة لتظهر.",
    loyaltyNoteExpiry: "تنتهي النقاط غير المستخدمة بعد 12 شهراً.",
    loyaltyShowQr: "عرض رمز QR",
    loyaltyViewActivity: "عرض النشاط",
    loyaltyBenefitsTierHint:
      "يبقى القفل حتى تصل فعلياً إلى ذلك المستوى؛ اختيار مستوى أعلى في المسار يعيد تمثيل المعاينة فقط (بطاقة أوضح مع بقاء القفل).",
    loyaltyTierStepperHint: "اختر مستوى لمعاينة المزايا",
    noRecentActivity: "لا يوجد نشاط مكافآت حديث بعد.",
    loyaltyEarn: "اكتساب",
    loyaltyBurn: "استهلاك",
    loyaltyPending: "نقاط معلّقة",
    loyaltyPendingLoadError: "تعذر تحميل النقاط المعلّقة.",
    loyaltyPendingTotalLabel: "إجمالي النقاط المعلّقة",
    loyaltyPendingInvoiceSummary: "{{count}} فاتورة في انتظار التأكيد",
    loyaltyPendingEmpty: "لا توجد فواتير في انتظار تأكيد النقاط.",
    loyaltyTxnLoadError: "تعذر تحميل سجل المعاملات.",
    loyaltyTxnEmpty: "لا توجد معاملات ولاء في هذه الفترة.",
    loyaltyTxnEmptyEarn: "لا توجد معاملات اكتساب في هذه الفترة.",
    loyaltyTxnEmptyBurn: "لا توجد معاملات استهلاك في هذه الفترة.",
    loyaltyTxnPointsLabel: "النقاط",
    editProfile: "تعديل الملف",
    editProfileSubtitle: "حدّث معلوماتك الشخصية وبيانات التواصل.",
    saveChanges: "حفظ التغييرات",
    cancel: "إلغاء",
    selectCountry: "اختر الدولة",
    savingProfile: "جاري الحفظ…",
    editProfileSuccess: "تم تحديث ملفك.",
    editProfileErrors: {
      firstNameRequired: "أدخل الاسم الأول.",
      firstNameMax: "الاسم الأول طويل جداً.",
      lastNameRequired: "أدخل اسم العائلة.",
      lastNameMax: "اسم العائلة طويل جداً.",
      emailRequired: "أدخل البريد الإلكتروني.",
      emailInvalid: "أدخل بريداً إلكترونياً صحيحاً.",
      phoneRequired: "أدخل رقم جوال صحيحاً (7 أرقام على الأقل).",
      phoneInvalid: "رقم الجوال طويل جداً.",
      dobInvalid: "أدخل تاريخ ميلاد صحيحاً.",
      dobFuture: "لا يمكن أن يكون تاريخ الميلاد في المستقبل.",
      dobMinAge: "يجب أن يكون عمرك 18 عاماً أو أكثر.",
      cityRequired: "اختر المدينة.",
      countryRequired: "اختر الدولة.",
      saveFailed: "تعذر حفظ الملف. حاول مرة أخرى.",
    },
    selectGender: "اختر الجنس",
    genderMale: "ذكر",
    genderFemale: "أنثى",
    genderPreferNotToSay: "أفضل عدم الإفصاح",
    manageVehicle: "إدارة",
    addNewVehicle: "إضافة مركبة",
    statusActive: "نشط",
    lastService: "آخر خدمة",
    mileageLabel: "{{value}} كم",
    mileageShortLabel: "عداد المسافات",
    loyaltyLoadError: "تعذر تحميل النقاط.",
    locationLabel: "الموقع",
    customerStage: "مرحلتك",
    navDeleteAccount: "حذف الحساب",
    deleteAccountSectionTitle: "حذف الحساب",
    deleteAccountSectionIntro:
      "طلب حذف حسابك. تتم معالجة الطلب من فريقنا. يمكنك توضيح السبب لمساعدتنا على التحسين.",
    deleteAccountButton: "طلب حذف الحساب",
    deleteAccountModalTitle: "حذف الحساب",
    deleteAccountModalIntro:
      "أخبرنا بسبب رغبتك في حذف الحساب. سنعالج طلبك وفقاً لسياساتنا.",
    deleteAccountReasonLabel: "السبب",
    deleteAccountReasonPlaceholder: "اختر سبباً",
    deleteAccountOtherLabel: "توضيح إضافي",
    deleteAccountOtherPlaceholder:
      "أضف تفاصيل (اختياري لبعض الأسباب؛ مطلوب عند اختيار «أخرى»)",
    deleteAccountCancel: "إلغاء",
    deleteAccountSubmit: "إرسال الطلب",
    deleteAccountSubmitting: "جاري الإرسال…",
    deleteAccountSuccess: "تم استلام طلبك. سيتم تسجيل خروجك.",
    deleteAccountError: "تعذر إرسال الطلب. حاول مرة أخرى أو تواصل مع الدعم.",
    deleteAccountPickReason: "يرجى اختيار سبب.",
    deleteAccountOtherRequired: "يرجى إضافة توضيح قصير عند اختيار «أخرى».",
    deleteAccountReasonPrivacy: "مخاوف تتعلق بالخصوصية",
    deleteAccountReasonTooManyEmails: "رسائل أو إشعارات كثيرة",
    deleteAccountReasonNoLongerNeed: "لم أعد بحاجة للخدمة",
    deleteAccountReasonOther: "أخرى",
  },
  myGarage: {
    title: "المرآب",
    subtitle: "أضف سياراتك وتتبع سجل الخدمات. اعرض الإصلاحات السابقة وسجلات الصيانة واحجز خدمات جديدة لمركباتك.",
    addCar: "إضافة سيارة",
    addNewCar: "إضافة سيارة جديدة",
    make: "الشركة المصنعة",
    model: "الموديل",
    year: "السنة",
    licensePlate: "رقم اللوحة",
    vin: "رقم الهيكل",
    mileage: "المسافة (كم)",
    color: "اللون",
    fuelType: "نوع الوقود",
    modelPlaceholder: "مثال: كامري، أكورد",
    platePlaceholder: "مثال: ABC 1234",
    vinPlaceholder: "رقم هيكل من 17 حرفاً",
    mileagePlaceholder: "عداد المسافات الحالي",
    colorPlaceholder: "مثال: أبيض، أسود",
    selectMake: "اختر الشركة",
    modelYear: "سنة الموديل",
    loadingEllipsis: "جاري التحميل…",
    selectMakeFirst: "اختر الشركة أولاً",
    selectYear: "اختر السنة",
    yearMustNotBeFuture: "سنة الموديل لا يمكن أن تكون في المستقبل.",
    selectFuel: "اختر نوع الوقود",
    cancel: "إلغاء",
    noCars: "لا توجد سيارات في مرآبك",
    noCarsDesc: "أضف أول سيارة لبدء تتبع الخدمات وسجل الصيانة.",
    addFirstCar: "أضف أول سيارة",
    viewHistory: "عرض السجل",
    addService: "إضافة خدمة",
    bookService: "ابحث عن الورشة",
    removeCar: "إزالة السيارة",
    addServiceRecord: "إضافة سجل خدمة",
    service: "الخدمة",
    date: "التاريخ",
    branch: "الفرع / المركز",
    cost: "التكلفة ({{CURRENCY}})",
    notes: "ملاحظات",
    selectService: "اختر الخدمة",
    selectBranch: "اختر الفرع",
    odometerPlaceholder: "قراءة عداد المسافات",
    costPlaceholder: "المبلغ المدفوع",
    notesPlaceholder: "أي ملاحظات إضافية...",
    addRecord: "إضافة السجل",
    serviceHistory: "سجل الخدمات",
    noRecords: "لا توجد سجلات خدمة بعد. أضف خدمة لبدء تتبع سجل سيارتك.",
    addFirstRecord: "أضف أول سجل خدمة",
    carNotFound: "السيارة غير موجودة",
    carNotFoundDesc: "هذه السيارة غير موجودة أو تم إزالتها.",
    backToGarage: "العودة للمرآب",
    retry: "إعادة المحاولة",
    addFormDescription:
      "اختر الشركة المصنعة وسنة الموديل والموديل ثم الفئة (المستوى). تُحفظ المركبات في حساب بترومين عبر خدمة المركبات.",
    signInToLinkSuffix: "حتى نتمكن من ربط السيارة بملف العميل الخاص بك.",
    trimVariant: "الفئة / المستوى",
    trimHint: "يُحمَّل من بيانات الفئات الرئيسية للموديل المحدد (مثال: {{pathExample}}).",
    trimHintPathExample: "/models/{modelId}/trims",
    engine: "المحرك",
    enginePlaceholder: "مثال: 4",
    bodyTypeLabel: "نوع الهيكل",
    bodyTypeSedan: "سيدان",
    bodyTypeSuv: "دفع رباعي",
    bodyTypeHatchback: "هاتشباك",
    bodyTypeCoupe: "كوبيه",
    bodyTypeWagon: "ستيشن",
    bodyTypeConvertible: "كابريوليه",
    bodyTypePickup: "بيك أب",
    bodyTypeVan: "فان",
    bodyTypeOther: "أخرى",
    fuelPetrol: "بنزين",
    fuelDiesel: "ديزل",
    fuelHybrid: "هجين",
    fuelElectric: "كهربائي",
    fuelCNG: "غاز طبيعي",
    vinDescriptionPlaceholder: "رقم تعريف المركبة",
    saving: "جاري الحفظ…",
    loadingVehicles: "جاري تحميل مركباتك…",
    noCarsGuestDesc:
      "سجّل الدخول لتحميل المركبات من حساب بترومين، أو أضف سيارة لحفظها على هذا الجهاز.",
    saveVehicleFailed: "تعذّر حفظ المركبة. حاول مرة أخرى.",
    signInToRegisterVehicle: "سجّل الدخول لتسجيل مركبة مع حسابك.",
    chooseMakeYearModel: "اختر الشركة المصنعة وسنة الموديل والموديل.",
    chooseTrimVariant: "اختر الفئة / المستوى لهذا الموديل.",
    invalidModelYear: "سنة الموديل غير صالحة.",
    unknownVehicle: "غير معروف",
    selectMakeAndYearFirst: "اختر الشركة والسنة أولاً",
    noModelsForYear: "لا توجد موديلات لهذه السنة",
    selectModel: "اختر الموديل",
    selectModelFirst: "اختر الموديل أولاً",
    loadingTrimsEllipsis: "جاري تحميل الفئات…",
    noTrimsForModel: "لا توجد فئات لهذا الموديل",
    selectTrim: "اختر الفئة",
    mileageKm: "كم",
  },
  expressPage: {
    heroImageAlt: "رصيف خدمة بترومين إكسبرس",
    heroTitle: "بترومين إكسبرس",
    heroSubtitle:
      "شبكة الصيانة السريعة الرائدة في المملكة — رعاية احترافية وقطع أصلية وفنيون معتمدون دون انتظار طويل.",
    bookCta: "احجز موعداً",
    servicesTitle: "خدماتنا المتخصصة",
    readMore: "اقرأ المزيد",
    svc1Desc: "زيوت وفلاتر عالية الجودة لحماية محركك.",
    svc2Desc: "باقات صيانة دورية مصممة لمركبتك.",
    svc3Desc: "فحص وتعبئة تكييف وراحة في كل موسم.",
    svc4Desc: "تركيب وتوازن وضغط إطارات.",
    svc5Desc: "فحص واستبدال بطاريات بعلامات موثوقة.",
    svc6Desc: "غسيل وتلميع صديق للبيئة.",
    whyTitle: "لماذا تختار بترومين إكسبرس؟",
    why1: "خدمة سريعة — تُنجز كثير من الإجراءات في أقل من 30 دقيقة.",
    why2: "فنيون معتمدون على المركبات الحديثة.",
    why3: "قطع أصلية لأداء دائم وراحة بال.",
    why4: "أكثر من 700 موقع في المملكة لسهولة الوصول.",
    whyImageAlt: "فني بترومين أثناء العمل",
    howTitle: "كيف تعمل الخدمة",
    step1Title: "اعثر على المحطة",
    step1Desc: "استخدم الباحث عن الورش لأقرب مركز إكسبرس.",
    step2Title: "توجّه بالسيارة",
    step2Desc: "زرنا في الوقت المناسب؛ سيرشدك فريقنا خلال الخدمة.",
    step3Title: "احصل على الخدمة",
    step3Desc: "أسعار واضحة وتنفيذ سريع لتعود للطريق.",
    bannerTitle: "مستعد لتجربة رعاية إكسبرس؟",
    bannerCta: "ابحث عن ورشة",
  },
  bodyPaintPage: {
    heroBadge: "مراكز معتمدة للهيكل والطلاء",
    heroImageAlt: "ورشة بترومين للهيكل والطلاء",
    findWorkshopCta: "ابحث عن ورشة",
    sectionTitle: "خدمات بترومين للهيكل والطلاء",
    svc1: "طلاء الهيكل بالكامل",
    svc2: "فيلم حماية طلاء السيارة",
    svc3: "تلميع خارجي وداخلي",
    svc4: "طلاء وحماية أسفل الهيكل",
    svc5: "استبدال الزجاج الأمامي",
    svc6: "تظليل النوافذ",
  },
  commercialPage: {
    heroImageAlt: "منشأة بترومين لصيانة المركبات التجارية والأساطيل",
    heroLogoAlt: "بترومين للعناية بالمركبات التجارية — الخدمة والإصلاح",
    heroLine1: "بترومين",
    heroLine2: "تجاري",
    heroLine3: "عناية المركبات",
    heroLead:
      "الشريك المفضل لإصلاح الأساطيل والمركبات التجارية، مع حلول صيانة متخصصة تبقي أعمالك تسير بسلاسة.",
    wordmarkItalic: "العناية بالمركبات التجارية",
    wordmarkSub: "إصلاح موثوق",
    sectionTitle: "حلول صيانة الأسطول من البداية للنهاية",
    statValue: "+10",
    statLabel: "مراكز خدمة متخصصة",
    exploreCta: "استكشف الخدمات",
    svc1a: "صيانة",
    svc1b: "وقائية",
    svc2a: "إصلاحات ميكانيكية",
    svc2b: "وكهربائية",
    svc3: "تشخيص",
    svc4a: "دعم الأساطيل",
    svc4b: "والحلول",
  },
  oilStopPage: {
    heroImageAlt: "رصيف خدمة ناشونال أويل ستوب السريعة",
    heroLogoAlt: "شعار ناشونال أويل ستوب",
    heroLine1: "ناشونال",
    heroLine2: "أويل ستوب",
    heroLead:
      "ناشونال أويل ستوب هو نموذج عناية بالسيارات قائم على الامتياز يركز على خدمة العملاء اليوميين على نطاق واسع. يجمع عمليات موحّدة مع نموذج خدمة بسيط وفعّال يجعل رعاية المركبات متاحة على نطاق أوسع مع تمكين توسع سريع عبر شركاء محليين.",
    exploreCta: "استكشف الخدمات",
    pillarsSectionLabel: "أبرز نموذج الامتياز",
    pillar1Title: "توسع قائم على الامتياز",
    pillar1Desc: "مصمم للنمو عبر شركاء محليين وبنموذج مثبت ومنظم",
    pillar2Title: "عمليات موحّدة",
    pillar2Desc: "تقديم خدمة متسق عبر جميع نقاط التماس",
    pillar3Title: "نموذج خدمة عالية الحجم",
    pillar3Desc: "مصمم لخدمة قاعدة عملاء كبيرة بكفاءة",
    pillar4Title: "ملاءمة قوية للسوق",
    pillar4Desc: "موضع للتنظيم والمنافسة ضمن قطاع مجزأ للغاية",
    capabilitiesTitle: "القدرات الأساسية",
    cap1Title: "تغيير زيت المحرك",
    cap1Desc: "زيوت متعددة العلامات بأسعار يومية منافسة",
    cap2Title: "فلاتر السيارة",
    cap2Desc: "فلتر زيت وجودة، وفلتر تكييف، وفلتر هواء",
    cap3Title: "مساحات الزجاج الأمامي",
    cap3Desc: "مساحات عالية الجودة لأقصى وضوح على الطريق",
    cap4Title: "ضغط الإطارات",
    cap4Desc: "ضغط احترافي لأداء أمثل لإطاراتك",
  },
  luxuryRepairPage: {
    heroImageAlt: "رصيف خدمة بترومين إكسبرس مع مركبة فاخرة",
    heroBadge: "الإصلاح الفاخر",
    heroTitle: "رعاية دقيقة للمركبات المتميزة وعالية الأداء",
    heroLead:
      "تجمع برامج الإصلاح الفاخر التشخيص المتوافق مع الوكيل والقطع الأصلية والفنيين ذوي الخبرة على المنصات الراقية — لخدمة الأنظمة المعقدة بالاهتمام الذي تستحقه.",
    findWorkshopCta: "ابحث عن ورشة",
    exploreServicesCta: "تصفح الخدمات",
    pillarsTitle: "لماذا تختار بترومين للإصلاح الفاخر",
    pillar1Title: "تشخيص يدرك العلامة",
    pillar1Body:
      "أدوات متقدمة وتشخيص قائم على البيانات يناسب نقل الحركة المتميز وإلكترونيات الهيكل وأنظمة مساعدة السائق.",
    pillar2Title: "قطع أصلية ومراقبة جودة",
    pillar2Body:
      "ممارسات التوريد والتركيب المتوافقة مع توقعات الصانع مع تتبع ووثائق تدعم الضمان.",
    pillar3Title: "خدمة احترافية رصينة",
    pillar3Body:
      "تواصل واضح وعناية دقيقة بالمركبة وعمليات ورشة مصممة لتوقعات عملاء القيمة العالية.",
    signalsHead: "لمحة سريعة",
    signal1: "تغطية متعددة العلامات المعتمدة",
    signal2: "قطع أصلية وتتبع",
    signal3: "فنيون معتمدون على مستوى المملكة",
    bottomTitle: "نحن جاهزون عندما تكون أنت كذلك",
    bottomLead: "اعثر على ورشة بترومين أو استكشف الخدمات المناسبة لمركبتك.",
  },
  about: {
    title: "من نحن",
    dpExploreServices: "استكشف الخدمات",
    dpExpressSvc1: "تغيير زيت المحرك والفلتر",
    dpExpressSvc2: "الصيانة الدورية",
    dpExpressSvc3: "خدمة تكييف سريعة",
    dpExpressSvc4: "العناية بالإطارات",
    dpExpressSvc5: "العناية بالبطارية",
    dpExpressSvc6: "غسيل بخار صديق للبيئة",
    dpAutoBadge: "مراكز إصلاح معتمدة متعددة العلامات",
    dpAutoNameLine1: "بترومين",
    dpAutoNameLine2: "أوتو كير",
    dpAutoDesc:
      "متخصصون في الصيانة والتشخيص والإصلاح لجميع العلامات. ملتزمون بتنقل المستقبل، وندير مراكز خدمة مخصصة للمركبات الكهربائية.",
    dpAutoLead: "مزود خدمة معتمد لنيسان وبي آي سي وفولفو",
    dpAutoStat50: "+50",
    dpAutoStat50L: "مراكز إصلاح",
    dpAutoStat10: "+10 EV",
    dpAutoStat10L: "فنّيون مدربون",
    dpAutoPremiumTitle: "خدمة فاخرة",
    dpAutoPremiumDesc:
      "عناية بالمركبات الفاخرة مع تشخيص احترافي وخدمة متميزة من فنيين معتمدين.",
    dpAutoEvTitle: "خبرة السيارات الكهربائية",
    dpAutoEvDesc:
      "تشخيص مخصص للمركبات الكهربائية، سلامة الجهد العالٍ، وصيانة تناسب منصات السيارات الحديثة.",
    dpAutoRepairTitle: "قدرات إصلاح شاملة",
    dpAutoRepair1: "إصلاح المحرك",
    dpAutoRepair2: "إصلاح نظام التعليق",
    dpAutoRepair3: "إصلاح ناقل الحركة",
    dpAutoRepair4: "إصلاح التكييف",
    dpAutoRepair5: "إصلاح الفرامل",
    dpAutoRepair6: "إصلاح كهربائي",
  },
  aboutPage: {
    heroImageAlt: "ورشة خدمة بترومين مع مركبات على الرافعات",
    heroSub: "نقود مستقبل حلول العناية بالسيارات",
    heroL1: "نقود مستقبل",
    heroL2a: "قطاع ",
    heroL2b: "السيارات",
    heroL3a: "خدمات ما بعد البيع",
    heroL3b: " و",
    heroL3c: "التنقل",
    missionBadge: "من نحن",
    missionTitle:
      "رائد عالمي في خدمات ما بعد بيع السيارات مبني على الثقة والحجم",
    missionCol1: `بترومين إكسبرس، إحدى شركات منظومة الدباغ المرموقة وشركة تابعة رئيسية لشركة بترومين، تُعد رائدة في صناعة خدمات السيارات بإرث يمتد لما يقارب عقدين.

انطلاقاً من المملكة العربية السعودية كسوقنا الأساسية، وسّعنا حضورنا في الإمارات والهند وماليزيا ومصر وباكستان، ملتزمين بالريادة العالمية ووضع العميل في قلب عملياتنا.`,
    missionCol2: `تطورنا يلتزم بمبادئ ريادة الأعمال الشاملة، ودمج قواعدها الذهبية في استراتيجيتنا لدعم النمو والابتكار والممارسات الأخلاقية.

نمثل علامات خدمة سيارات مرموقة ونبني علاقات دائمة مبنية على الثقة مع الشركاء والعملاء. نجاحنا يأتي من تلبية احتياجاتهم استباقياً وفق هذه المبادئ.`,
    stat25: "+25",
    stat25L: "سنوات من التميز",
    stat93: "93٪",
    stat93L: "تقييم رضا العملاء",
    stat50: "+50",
    stat50L: "جوائز وتكريمات",
    stat800: "+800",
    stat800L: "مراكز خدمة",
    stat30m: "+30M",
    stat30mL: "مركبة تمت خدمتها عالمياً",
    purposePill: "الغرض والقيم الأساسية",
    purposeSectionTitle: "منصة لدورة حياة المركبة بالكامل",
    purposeImageAlt: "فني يعمل تحت مركبة في رصيف خدمة بترومين",
    cardPurposeTitle: "غرضنا",
    cardPurposeBody:
      "تقديم حلول موثوقة ومتصلة لما بعد بيع السيارات تدعم التنقل على مدى دورة حياة المركبة بأكملها.",
    cardVisionTitle: "رؤيتنا",
    cardVisionBody:
      "تشكيل مستقبل خدمات العناية بالسيارات وأنظمة قطع الغيار عبر منطقة الشرق الأوسط وأفريقيا وآسيا من خلال التوسع والذكاء والابتكار المستدام.",
    cardMissionTitle: "مهمتنا",
    cardMissionBody:
      "نربط بين الخدمات وقطع الغيار والتكنولوجيا لتبسيط العناية بالسيارات، مع تقديم قيمة في كل مرحلة من مراحل دورة حياة المركبة، مع تعزيز الاستدامة والأثر المجتمعي.",
    cardVcfTitle: "إطار خلق القيمة",
    pillar1Title: "الاستدامة",
    pillar1Body:
      "نُدمج المسؤولية البيئية والاجتماعية في طريقة عملنا وتوسعنا وخدمتنا لضمان قيمة طويلة الأمد عبر دورة حياة التنقل.",
    pillar2Title: "التميز في الجودة والسلامة",
    pillar2Body:
      "معايير صارمة وأنظمة سلامة وتنفيذ خدمة يضمن نتائج موثوقة في كل نقطة تواصل مع العميل.",
    pillar3Title: "التميز الشبكي",
    pillar3Body:
      "نقدم خدمات ما بعد بيع موثوقة عبر شبكة متصلة تمنح العملاء وصولاً معتمداً وجودة متسقة أينما تفاعلوا معنا.",
    expressHeroImageAlt: "مركز بترومين إكسبرس مع مركبات على الرافعات",
    expressLogoAlt: "شعار بترومين إكسبرس",
    expressBadge: "حلول عناية سريعة بالمركبات",
    expressNameLine1: "بترومين",
    expressNameLine2: "إكسبرس",
    expressHeroDesc:
      "مركز خدمة سريعة موثوق يقدم عناية شاملة بالمركبة، مع أبرز علامات الزيت والبطارية والإطارات، وخدمات التكييف وغسيل البخار تحت سقف واحد.",
    expressLead: "ثاني أكبر شبكة خدمة احترافية مملوكة للشركة على مستوى العالم.",
    expressStat700: "700+",
    expressStat700L: "مراكز خدمة",
    expressStat3000: "3000+",
    expressStat3000L: "فنّيون مدربون",
    expressServicesTitle: "خدمات بترومين إكسبرس",
    autocareHeroImageAlt: "ورشة بترومين أوتو كير مع فني يخدم مركبة",
    autocareBadge: "مراكز إصلاح معتمدة متعددة العلامات",
    autocareTitle: "بترومين أوتو كير",
    autocareHeroDesc:
      "متخصصون في الصيانة والتشخيص والإصلاح لجميع العلامات. التزاماً بتنقل المستقبل، ندير أيضاً مراكز خدمة مخصصة للمركبات الكهربائية.",
    autocareCertifiedLine: "مقدم خدمة معتمد لنيسان وبايك وفولفو",
    autocareStat50: "50+",
    autocareStat50L: "مراكز إصلاح",
    autocareStat10: "10+",
    autocareStat10Suffix: "",
    autocareStat10L: "فنّيون مدربون على السيارات الكهربائية",
    autocareServicesTitle: "خدمات بترومين أوتو كير",
    tristarHeroImageAlt: "ورشة بترومين تراي ستار للإصلاحات الثقيلة",
    tristarLogoAlt: "شعار بترومين تراي ستار",
    tristarBadge: "خدمة الإصلاح الثقيل",
    tristarTitle: "بترومين تراي ستار",
    tristarHeroDesc:
      "شريك موثوق لإعادة بناء المحركات والإصلاحات الثقيلة، بخبرة تمتد لعقود للحفاظ على أفضل أداء لمركباتكم.",
    tristarServicesTitle: "الخدمات:",
    tristarService1: "إعادة بناء وإصلاح المحرك",
    tristarService2: "إعادة بناء وإصلاح ناقل الحركة",
    tristarService3: "إصلاح ميكانيكي",
    tristarService4: "إصلاح كهربائي",
    tristarFeature1Value: "قطع",
    tristarFeature1Label: "أصلية",
    tristarFeature2Value: "+8",
    tristarFeature2Label: "محطات",
    tristarFeature3Value: "معدات",
    tristarFeature3Label: "متقدمة",
    tristarFeature4Value: "إنتاج",
    tristarFeature4Label: "محول العزم",
    tristarSideLabel: "بترومين تراي ستار",
    bodyPaintHeroImageAlt: "فني طلاء وهيكل يعمل على مركبة في ورشة بترومين",
    bodyPaintLogoAlt: "شعار بترومين للطلاء والهيكل والإصلاح",
    bodyPaintShowcaseBadge: "شريكك المفضل لإصلاح الحوادث",
    bodyPaintShowcaseDesc:
      "متخصصون في إعادة الطلاء والترميم، نجمع بين الحرفية العالية والتقنيات المتقدمة.",
    bodyPaintWordmarkBrand: "بترومين",
    bodyPaintWordmarkLine: "الهيكل والطلاء",
    bodyPaintStat10: "10+",
    bodyPaintStat10L: "مراكز متخصصة",
    bodyPaintStatOem: "OEM",
    bodyPaintStatOemL: "معدات معتمدة من الصانع",
    evMobilityHeroImageAlt: "مركبات كهربائية ومحطات شحن في بيئة تنقل بترومين",
    evMobilityBadge: "حلول المركبات الكهربائية",
    evMobilityTitle: "نقود مستقبل التنقل",
    evMobilityDesc:
      "تقدّم شركة بترومين أوتو كير عرضاً متكاملاً للمركبات الكهربائية يجمع بين قدرات الإصلاح المعتمدة وبنية الشحن لتجربة تنقل كهربائي سلس.",
    evServiceTitle: "خدمة وإصلاح المركبات الكهربائية",
    evServiceLead:
      "مرافقنا للمركبات الكهربائية مجهزة للتعامل مع التشخيص والإصلاح المتقدمين، بدعم من فنيين معتمدين وأدوات متخصصة.",
    evService1Label: "فنّيون معتمدون IMI TechSafe™",
    evService2Label: "تشخيص وإصلاح متقدم للمركبات الكهربائية",
    evService3Label: "معايير سلامة الجهد العالي",
    evService4Label: "برامج تدريب تقني مستمر",
    evChargingTitle: "شبكة شحن المركبات الكهربائية",
    evChargingLead:
      "نوسّع قدرات الشحن للمركبات الكهربائية لتوفير حلول شحن مريحة ومتاحة عبر شبكة خدماتنا.",
    evCharging1Label: "أكثر من 100 نقطة شحن للمركبات الكهربائية عبر شبكتنا",
    evCharging2Label: "مواقع استراتيجية عند مراكز الخدمة الرئيسية",
    evCharging3Label: "حلول شحن موثوقة وفعّالة",
    evFleetSolutionsTitle: "حلول صيانة الأسطول من البداية للنهاية",
    evFleetSol1: "خبرة معتمدة في تقنيات المركبات الكهربائية",
    evFleetSol2: "مرافق مخصّصة وجاهزة للمركبات الكهربائية",
    evFleetSol3: "التركيز على السلامة والدقة والموثوقية",
    evFleetSol4: "دعم التحوّل إلى تنقل مستدام",
    sustainabilityHeroBadge: "وعدنا بالاستدامة",
    sustainabilityHeroTitle: "نبني مستقبلاً مستداماً، معاً!",
    sustainabilityHeroBody:
      "نلتزم بتقليل أثرنا البيئي مع الحفاظ على جودة الخدمة التي يتوقعها عملاؤنا. ذلك يعني استخداماً أذكى للطاقة، وإدارة مسؤولة للمياه، وتوسيع البنية التحتية التي تدعم تنقلاً أنظفاً عبر شبكتنا.",
    sustainabilityHeroImageAlt:
      "مشهد حضري يوضح التزام بترومين بالاستدامة والتنقل والمساحات الخضراء",
    sustainabilityInitiativesTitle: "مبادراتنا\nللاستدامة",
    sustainabilityInitiativesIntro:
      "تحوّل هذه البرامج وعدنا إلى أفعال ملموسة—خطوات نتخذها في ورشنا ومجتمعاتنا للعمل بكفاءة ومسؤولية أكبر.",
    sustainabilityInit1: "تركيب شواحن للمركبات الكهربائية",
    sustainabilityInit2: "تقنيات تكييف مستدامة",
    sustainabilityInit3: "توفير المياه مع غسيل السيارات بالبخار الصديق للبيئة",
    luxuryShowcaseHeroAlt: "فني مع جهاز لوحي داخل مركبة فاخرة في رصيف خدمة بترومين",
    luxuryShowcaseBadge: "حلول العناية بالمركبات الفاخرة",
    luxuryShowcaseHeroTitle: "إصلاح متخصص للمركبات الفاخرة",
    luxuryShowcaseHeroLead:
      "تجمع برامج الإصلاح الفاخرة بين التشخيص المتوافق مع الشركة المصنّعة والقطع الأصلية وفنّيين ذوي خبرة مع المنصات الراقية — لتُخدم الأنظمة المعقّدة بالاهتمام الذي تستحقه.",
    luxuryShowcaseCapabilitiesTitle: "قدرات متخصصة",
    luxuryShowcaseCapabilitiesIntro:
      "صُممت مراكز الخدمة المميزة لدينا لتلبية معايير العلامات الراقية في قطاع السيارات:",
    luxuryShowcaseCap1: "تشخيص متقدم ومعدات متخصصة",
    luxuryShowcaseCap2: "عمليات إصلاح متوافقة مع الشركة المصنّعة",
    luxuryShowcaseCap3: "متخصصون معتمدون للأنظمة المعقّدة",
    luxuryShowcaseCap4: "مراقبة جودة شفافة وتتبع للقطع",
    luxuryShowcasePremiumTitle: "تجربة الخدمة المميزة",
    luxuryShowcasePrem1: "بيئات خدمة مخصّصة للمركبات الفاخرة",
    luxuryShowcasePrem2: "تقديم خدمة شفاف وعالي الجودة",
    luxuryShowcasePrem3: "لوجستيات قطع ومواعيد موثوقة يمكن الاعتماد عليها",
    luxuryShowcasePrem4: "تنسيق ورشي متكامل ومعايير حرفية عالية",
    globalMarketsBadge: "الأسواق الدولية",
    globalMarketsTitle: "توسيع التميز في قطاع ما بعد بيع السيارات عالمياً",
    globalMarkets1Title: "نهجنا",
    globalMarkets1Desc: "استراتيجيات سوق مرنة تضمن نمواً مستداماً وملاءمة محلية.",
    globalMarkets2Title: "مشاريع مشتركة",
    globalMarkets2Desc: "شراكة مع خبراء محليين لدمج فهم السوق مع التميز التشغيلي.",
    globalMarkets3Title: "نموذج الامتياز",
    globalMarkets3Desc: "توسع سريع عبر شبكة شركاء منظمة.",
    globalMarkets4Title: "عمليات مملوكة للشركة",
    globalMarkets4Desc: "ضمان الجودة والاتساق في الأسواق الرئيسية.",
    multiBrandBadge: "العلامات",
    multiBrandTitle: "تغطية متعددة العلامات",
    multiBrandLogosDescription:
      "صف زخرفي من شعارات العلامات التجارية الكبرى للسيارات يتحرك مع تمرير الصفحة.",
    trustedPartnersBadge: "الشركاء",
    trustedPartnersTitle: "شبكة الشركاء الموثوقة",
    trustedPartnersLogosDescription:
      "صف زخرفي من شعارات الشركاء يتحرك أفقياً مع تمرير الصفحة.",
    newsroomHeading: "غرفة الأخبار",
    newsroomLearnMore: "اعرف المزيد",
    newsroomCard1Title: "تمكين السائقات من خلال تدريب أساسي على الوعي بالمركبة",
    newsroomCard1Desc:
      "نظّمت بترومين أوتو كير تدريباً على مستوى المملكة لرفع الوعي بالمركبة لتمكين النساء من التحكم بثقة أكبر في مركباتهن.",
    newsroomCard1ImageAlt: "فني بترومين يشرح مكوّنات المحرك تحت غطاء المحرك",
    newsroomCard2Title: "مبادراتنا للاستدامة",
    newsroomCard2Desc:
      "تابع آخر التطورات والمبادرات ومحطات النمو بينما نواصل التوسع والابتكار بمسؤولية.",
    newsroomCard2ImageAlt: "صورة بأسلوب رياضي تبرز الشراكات والأداء",
    newsroomCard3Title: "فائز بعدة جوائز ذهبية في GCXA-22",
    newsroomCard3Desc:
      "فازت بترومين بجائزة الفائز العام وبلقبين ذهبيين في جوائز تجربة العملاء الخليجية GCXA 22.",
    newsroomCard3ImageAlt: "فريق بترومين على منصة حفل توزيع الجوائز",
    awardsBadge: "الجوائز",
    awardsCarouselLabel: "مقتطفات الجوائز، تمرير تلقائي",
    awardsTitle: "نضع معياراً\nللتميز في الخدمة",
    awardsCard1Ribbon: "نحتفل بفوزنا بـ 6 جوائز ستيفي!",
    awardsCard1Title: "جوائز ستيفي الشرق الأوسط",
    awardsCard1Subtitle: "الجائزة الذهبية – إنجاز مبتكر في الاستدامة 2024",
    awardsCard1ImageAlt: "جوائز ستيفي معروضة في احتفال",
    awardsCard2Title: "فوز بعدة جوائز ذهبية في GCXA-22",
    awardsCard2Subtitle: "فائز بعدة جوائز ذهبية في جوائز تجربة العملاء الخليجية 2022",
    awardsCard2ImageAlt: "ممثلو بترومين على منصة حفل جوائز GCXA",
    awardsCard3Title: "تقدير للتميز في القطاع",
    awardsCard3Subtitle: "تكريم فرقنا على تقديم خدمة متميزة والتزام بالعملاء في المنطقة.",
    awardsCard3ImageAlt: "لحظة من حفل الجوائز يبرز إنجازات بترومين",
    globalPresenceBadge: "الحضور العالمي",
    globalPresenceTitle: "من جذور سعودية\nإلى توسع إقليمي\nوعالمي",
    globalPresenceBody:
      "من جذور متواضعة في المملكة العربية السعودية على مدى نحو عقدين، أصبحت شركة بترومين أوتو كير اليوم أعمالاً عالمية محترمة وناجحة ومتنوعة. نحن حاضرون في أكثر من 7 دول ولدينا خطط طموحة للمزيد من النمو.",
    globalPresenceMapAlt: "خريطة عالمية توضح حضور بترومين عبر المناطق",
    globalPresenceMarkerEgypt: "مصر",
    globalPresenceMarkerSaudiArabia: "المملكة العربية السعودية",
    globalPresenceMarkerUae: "الإمارات العربية المتحدة",
    globalPresenceMarkerPakistan: "باكستان",
    globalPresenceMarkerIndia: "الهند",
    globalPresenceMarkerMalaysia: "ماليزيا",
    navEyebrow: "في هذه الصفحة",
    navAriaLabel: "أقسام صفحة من نحن",
    navChapterExpress: "بترومين إكسبريس",
    navChapterAutocare: "بترومين أوتو كير",
    navChapterBodyPaint: "بترومين بودي آند بينت",
    navChapterCommercial: "بترومين للمركبات التجارية",
    navChapterOilStop: "ناشونال أويل ستوب",
    navChapterEv: "السيارات الكهربائية والتنقل",
    navChapterPremium: "الفخامة والعالمية",
    navChapterSustainability: "الاستدامة",
    navChapterSpotlight: "الشركاء والجوائز",
    navChapterNationalAutoParts: "ناشونال أوتو بارتس",
    autoPartsHeroImageAlt: "مركبات تجارية ولوجستيات تمثل توزيع ناشونال أوتو بارتس",
    autoPartsLogoAlt: "شعار ناشونال أوتو بارتس",
    autoPartsBadge: "توزيع B2B",
    autoPartsNameLine1: "ناشونال",
    autoPartsNameLine2: "أوتو بارتس",
    autoPartsTagline: "عمود توزيع B2B الفقري في نظام ما بعد البيع لدينا",
    autoPartsHeroDesc:
      "ناشونال أوتو بارتس موزّع B2B موجّه للسوق، يورّد قطع غيار سيارات عالية الجودة لوكلاء التجزئة والأساطيل والموزّعين. نحن موزّع قطع غيار حصري لعلامات إنرجايزر وموبار وغلف ونابا.",
    autoPartsStat16k: "16 ألف",
    autoPartsStat16kL: "م² مساحة مستودع",
    autoPartsStat15k: "15 ألف+",
    autoPartsStat15kL: "أصناف فريدة وفي نمو",
    autoPartsStat28m: "2.8 مليون",
    autoPartsStat28mL: "وحدات مدخلة ومخرجة",
    autoPartsPartnersTitle: "توزيع حصري لقطع الغيار",
    autoPartsPartnerEnergizer: "Energizer",
    autoPartsPartnerMopar: "Mopar",
    autoPartsPartnerGulf: "Gulf",
    autoPartsPartnerNapa: "NAPA",
    scrollHint: "اسحب للأسفل",
    navChapterTristar: "بترومين تريستار",
  },
  app: {
    getApp: "احصل على التطبيق",
    garageTitle: "حافظ على مرآبك الافتراضي الشخصي",
    garageSub: "حمّل التطبيق لتعزيز العناية بسيارتك — احجز الخدمات، تتبع المكافآت، والمزيد.",
    googlePlay: "جوجل بلاي",
    appStore: "آب ستور",
    getItOn: "احصل عليه من",
    downloadOn: "متوفر على",
    featureBook: "احجز الخدمات",
    featureRewards: "تتبع المكافآت",
    featureGarage: "إدارة المرآب",
  },
  partners: {
    title: "شركاؤنا في قطع الغيار",
    subtitle: "نستخدم قطع غيار أصلية فقط من علامات عالمية موثوقة لراحة بالك",
    genuineParts: "قطع أصلية",
    oemQuality: "جودة OEM",
    warrantyBacked: "مضمونة بالضمان",
    fastAvailability: "متوفرة بسرعة",
  },
  cookiesBanner: {
    ariaLabel: "الموافقة على ملفات تعريف الارتباط",
    message:
      "نستخدم ملفات تعريف الارتباط لتحسين تجربتك وتذكر تفضيلاتك وفهم استخدام الموقع. بمتابعة التصفح، فإنك توافق على استخدامنا لهذه الملفات.",
    accept: "موافقة",
    cookiePolicy: "سياسة ملفات تعريف الارتباط",
    privacyPolicy: "سياسة الخصوصية",
  },
  howServiceWorks: {
   title: "كيف تعمل خدمة بترومين",
   step1Title: "استكشف خدماتك",
   step1Desc: "تحقق من الخدمة التي تحتاجها من بترومين اكسبريس",
   step2Title: "قم بزيارة ورشة بترومين اكسبريس",
   step2Desc: "سيتم اعتماد أي إصلاحات إضافية قبل المتابعة.",
   step3Title: "احصل على خدمة لسيارتك",
   step3Desc: "السيارة جاهزة للاستلام بعد الانتهاء من الخدمة"
  },
   notFound: {
    metaTitle: "الصفحة غير موجودة | بترومين إكسبريس",
    code: "404",
    title: "الصفحة غير موجودة",
    description:
      "الصفحة التي تبحث عنها غير موجودة، أو ربما تم نقلها، أو أن الرابط غير صحيح.",
    backHome: "العودة للرئيسية",
    findWorkshop: "اعثر على ورشة",
    contactUs: "تواصل معنا",
  },
  consent: {
    title: "الموافقة على التخصيص والتواصل",
    subtitle: "بياناتك تحت سيطرتك",
    desc: "لنمنحك تجربة أكثر سلاسة وملاءمة، نستخدم بعض الأذونات لإرسال التحديثات والتذكيرات والتوصيات المهمة لك. أنت دائمًا المتحكم — ويمكنك تعديل هذه التفضيلات في أي وقت من الإعدادات.",
    communication_preferences: "تفضيلات التواصل",
    preference_desc: "نستخدم القنوات التالية لإبقائك على اطلاع بالتحديثات المهمة والخدمات والعروض.",
    email: "البريد الإلكتروني",
    email_desc: "استلم تحديثات الخدمة والتذكيرات والفواتير والتوصيات المخصصة.",
    sms: "رسائل SMS",
    sms_desc: "احصل على التنبيهات العاجلة مثل التأكيدات والإشعارات المهمة.",
    whatsapp: "واتساب",
    whatsapp_desc: "تحديثات سريعة وتنسيق للخدمة وتذكيرات عبر واتساب لتواصل أسرع.",
    push_notifications: "إشعارات الدفع",
    push_notifications_desc: "ابقَ على اطلاع لحظيًا بالتنبيهات والتذكيرات والعروض ذات الصلة.",
    location_access: "إذن الموقع",
    location_access_desc: "اسمح بالوصول للموقع لإظهار الخدمات القريبة والتوفر الدقيق والتوصيات المبنية على الموقع.",
    location_access_consent: "يُستخدم موقعك فقط لتحسين تجربتك ولا تتم مشاركته أبدًا دون موافقتك.",
  },
} as const;
